/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconPhone({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1.6em" viewBox="0 0 10 16" className={className} {...props}>  <path fill="currentColor" d="M9.94 13.697l-1.357-2.895a.86.86 0 00-.517-.454.858.858 0 00-.63.039l-1.298.608-.007.003a.75.75 0 01-.942-.25 15.638 15.638 0 01-1.302-2.273 15.606 15.606 0 01-.914-2.457.752.752 0 01.411-.884l.006-.003 1.298-.608a.856.856 0 00.433-.46.86.86 0 00-.018-.688L3.747.481A.86.86 0 003.23.027L3.183.013c.008-.012-.978-.045-1.418.161-2.19 1.026-2.366 5.27-.394 9.48 1.833 3.91 4.875 6.415 7.054 5.928 0 0 .33-.093.483-.164.44-.206.949-.758 1.05-1.033a.889.889 0 00-.018-.688" /></svg>
  );
}

IconPhone.propTypes = iconPropTypes;
IconPhone.defaultProps = iconDefaultProps;
